import { SupplierController } from "controllers";
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";

const country = localStorage.getItem('country');

async function dataStream(callback) {
    const suppliers = await SupplierController.getSuppliers(country);
    callback(sortArrayPipe.transform(suppliers, 'value'));
}

const SupplierSelect = withBaseSelect([], dataStream, true);
export default SupplierSelect;
